import React from 'react';

function PlaylistItem({ item, onClick }) {
  const itemStyle = {
    display: 'flex',
    marginBottom: '12px',
    cursor: 'pointer',
    backgroundColor: '#2a2a2a',
    borderRadius: '8px',
    overflow: 'hidden',
    transition: 'all 0.2s ease',
    border: '1px solid transparent'
  };

  const itemHoverStyle = {
    backgroundColor: '#333',
    border: '1px solid #D7B615'
  };

  const thumbnailContainerStyle = {
    position: 'relative',
    width: '120px',
    height: '68px',
    flexShrink: 0,
    backgroundColor: '#000'
  };

  const thumbnailStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  };

  const playIconStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'white',
    fontSize: '1.8em',
    backgroundColor: 'rgba(0,0,0,0.6)',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '3px'
  };

  const contentStyle = {
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1
  };

  const titleStyle = {
    fontSize: '0.85em',
    color: 'rgba(255, 255, 255, 0.95)',
    lineHeight: '1.3',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    marginBottom: '4px'
  };

  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div
      style={isHovered ? {...itemStyle, ...itemHoverStyle} : itemStyle}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={thumbnailContainerStyle}>
        <img
          src={item.thumbnailUrl || 'https://placehold.co/120x68/222/999?text=Video'}
          alt={item.title}
          style={thumbnailStyle}
        />
        <span style={playIconStyle}>▶</span>
      </div>
      <div style={contentStyle}>
        <span style={titleStyle}>{item.title}</span>
      </div>
    </div>
  );
}

export default PlaylistItem;